import React, { useEffect } from "react";
import FloatingLogoAndButton from "../FloatingLogoAndButton/FloatingLogoAndButton";
import { Helmet } from "react-helmet-async";
import heroImg from "../../assets/images/bydgoszcz/cigar/considerate-agency-hero.jpg";
import imgHumidor from "../../assets/images/bydgoszcz/cigar/considerate-agency-hum.jpg";
import imgConditions from "../../assets/images/bydgoszcz/cigar/jonathan-cosens-hydro.jpg";
import imgContainer from "../../assets/images/bydgoszcz/cigar/considerate-agency-without-hum.jpg";
import imgMistake from "../../assets/images/bydgoszcz/cigar/considerate-agency-no.jpg";
import imgCTA from "../../assets/images/bydgoszcz/cigar/andrey-tikhonovskiy-prem.jpg";

export default function JakPrzechowywacCygara() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Article",
            headline: "Jak przechowywać cygara?",
            description:
              "Sprawdź jak przechowywać cygara, jakie są idealne warunki i czym jest humidor.",
            author: {
              "@type": "Organization",
              name: "Whitebull Steakhouse",
            },
            mainEntityOfPage: {
              "@type": "WebPage",
              "@id": "https://whitebull.com.pl/jak-przechowywac-cygara",
            },
          })}
        </script>

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "Jak przechowywać cygara?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Najlepiej w humidorze, w wilgotności 65–72% i temperaturze 18–21°C.",
                },
              },
              {
                "@type": "Question",
                name: "Czy można przechowywać cygara w lodówce?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Nie – lodówka wysusza cygara i pogarsza ich jakość.",
                },
              },
            ],
          })}
        </script>
      </Helmet>
      <div className="bg-black text-white min-h-screen flex flex-col items-center px-4 py-10">
        <FloatingLogoAndButton />
        <div className="mb-20"></div>
        {/* HERO */}
        <section className="max-w-4xl text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            Jak przechowywać cygara?
          </h1>
          <img
            src={heroImg}
            alt="cygara humidor przechowywanie premium"
            className="w-full max-w-4xl h-80 object-cover mb-8"
          />
          <p className="text-lg opacity-90">
            Odpowiednie przechowywanie cygar ma kluczowe znaczenie dla ich
            smaku, aromatu i jakości. Sprawdź, jak robić to poprawnie.
          </p>
        </section>

        {/* HUMIDOR */}
        <section className="max-w-3xl mb-12">
          <h2 className="text-2xl font-semibold mb-4">
            🌡️ Humidor – podstawa przechowywania
          </h2>
          <p className="opacity-90">
            Najlepszym miejscem do przechowywania cygar jest humidor – specjalne
            pudełko utrzymujące odpowiednią wilgotność i temperaturę.
          </p>
          <img
            src={imgHumidor}
            alt="humidor cygara przechowywanie"
            className="w-full h-64 object-cover mt-6"
          />
        </section>

        {/* WARUNKI */}
        <section className="max-w-3xl mb-12">
          <h2 className="text-2xl font-semibold mb-4">📊 Idealne warunki</h2>

          <ul className="space-y-2 opacity-90">
            <li>Wilgotność: 65–72%</li>
            <li>Temperatura: 18–21°C</li>
          </ul>

          <img
            src={imgConditions}
            alt="wilgotność cygara higrometr"
            className="min-w-full h-64 object-cover mt-6"
          />

          <p className="mt-4 opacity-90">
            Zbyt suche powietrze wysusza cygaro, a zbyt wilgotne może prowadzić
            do pleśni.
          </p>
        </section>

        {/* BEZ HUMIDORA */}
        <section className="max-w-3xl mb-12">
          <img
            src={imgContainer}
            alt="przechowywanie cygar pojemnik"
            className="w-full h-64 object-cover mt-6"
          />
          <h2 className="text-2xl font-semibold mb-4">
            🧳 Jak przechowywać cygara bez humidora?
          </h2>

          <p className="opacity-90">
            Jeśli nie masz humidora, możesz użyć szczelnego pojemnika z
            niewielkim źródłem wilgoci (np. specjalne saszetki). To rozwiązanie
            tymczasowe.
          </p>
        </section>

        {/* BŁĘDY */}
        <section className="max-w-3xl mb-12">
          <h2 className="text-2xl font-semibold mb-4">❌ Najczęstsze błędy</h2>
          <img
            src={imgMistake}
            alt="lodówka błąd przechowywania cygar"
            className="w-full h-64 object-cover mt-6"
          />
          <ul className="space-y-2 opacity-90">
            <li>przechowywanie w lodówce</li>
            <li>zbyt wysoka wilgotność</li>
            <li>bezpośrednie światło słoneczne</li>
            <li>brak kontroli temperatury</li>
          </ul>
        </section>

        {/* EXPERIENCE */}
        <section className="max-w-3xl text-center mb-12">
          <h2 className="text-2xl font-semibold mb-4">🍽️ Dlaczego to ważne?</h2>
          <p className="opacity-90">
            Dobrze przechowywane cygaro zachowuje pełnię aromatu i zapewnia
            znacznie lepsze doświadczenie podczas palenia.
          </p>
        </section>

        {/* CTA */}
        <section className="text-center mb-12">
          <a href="/palarnia-cygar-bydgoszcz" className="underline text-lg">
            → Doświadcz palarni cygar w Whitebull
          </a>
        </section>

        {/* LINKI */}
        <section className="text-center space-y-2">
          <a href="/jak-palic-cygaro" className="underline opacity-70 block">
            → Jak palić cygaro
          </a>
          <a href="/rodzaje-cygar" className="underline opacity-70 block">
            → Rodzaje cygar
          </a>
          <a href="/historia-cygar" className="underline opacity-70 block">
            → Historia cygar
          </a>
        </section>
      </div>
    </>
  );
}
